<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
        <div class="content">
            <div class="content-header">
                <Backbutton />
                Результаты конкурсного отбора
            </div><br>
            <br>
            <table style="width: 1200px !important">
                <tr>
                    <th>№</th>
                    <th>Наименование КЦОП (Компании)</th>
                    <th style="width: 100px !important">Всего Оценок по аспектам</th>
                    <th style="width: 100px !important">Введено оценок экспертами</th>
                    <th style="width: 100px !important">Кол-во экспертов, которые выставили оценки</th>
                    <th style="width: 100px !important">Результат (Сумма всех оценок)</th>
                    <th>Статус</th>
                    <th>Доп. статус</th>
                </tr>
                <tr v-for="resault, index in resaults" :key="resault.kcop_id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ resault.company_name }}</td>
                    <td>{{ resault.Kcop_criteria_aspect_count }}</td>
                    <td>{{ resault.kcop_marks_count }}</td>
                    <td>{{ resault.kcop_marks_experts_count }}</td>
                    <td>{{ resault.kcop_resaults }}</td>
                    <td>{{ resault.status_id }}</td>
                    <td>{{ resault.ext_status }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Success from '@/components/elements/success.vue'
    import Error from '@/components/elements/error.vue'
    import Backbutton from '@/components/elements/bacl-button.vue'

    export default {
        name: 'Kcop_resault',
        components: {
            Success, Error, Backbutton
        },
        data() {
            return {
                /* common vars */
                isSuccess: false,
                operation_info: '',
                error_text: '',
                isError: '',
                /* common vars */
                resaults: {}
            }
        },
        methods: {
            get_resaults() {
                let loader = this.$loading.show()
                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.axios.get(process.env.VUE_APP_API_URL + '/api/kcop_resaults')
                    .then(response => {
                        this.resaults = response.data.data
                        loader.hide();
                    })
                    .catch(error => {
                        //let loader = this.$loading
                        loader.hide();
                        this.error_text = error.response.status + ' ' + error.response.data.data;
                        this.isError = true;
            });
            }
        },
        created() {
            this.get_resaults()
        }
    }
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>